var map = {
	"./at.svg": 5675,
	"./au.svg": 1482,
	"./bg.svg": 1453,
	"./ca.svg": 8460,
	"./de.svg": 6669,
	"./dk.svg": 363,
	"./es.svg": 7392,
	"./fr.svg": 3452,
	"./gb.svg": 2539,
	"./ie.svg": 3266,
	"./it.svg": 9139,
	"./lu.svg": 4245,
	"./nl.svg": 418,
	"./no.svg": 4465,
	"./nz.svg": 1660,
	"./pl.svg": 5920,
	"./pt.svg": 3592,
	"./ro.svg": 3781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8002;